<template>
    <el-dialog
      title="Новый прибор"
      :visible="visible"
      :before-close="close"
      @opened="onOpen"
      width="620px"
    >
    <el-form ref="addForm" :rules="addFormRules" :model="addForm" class="dialog-form">
      <div class="dialog-form__title">Добавление нового устройства</div>
      <el-form-item label="Название" prop="name">
        <el-input  name="name" ref="autoFocus" placeholder="Введите название прибора..." v-model="addForm.name"></el-input>
      </el-form-item>
      <el-form-item label="Тип" prop="type">
        <el-select v-model="addForm.type" class="dialog__select">
          <el-option value="20" label="1" />
          <el-option value="40" label="2" />
          <el-option value="60" label="3" />
        </el-select>
      </el-form-item>

    </el-form>

      <footer-buttons>
        <el-button
          type="primary"
          :loading="loadAddForm"
          @click="saveForm(true)"
        >Создать новый прибор
        </el-button>
        <el-button
          :loading="loadBtn"
          @click="close"
        >Отмена
        </el-button>
      </footer-buttons>

  </el-dialog>
</template>

<script>
import FooterButtons from '@/components/dialog/FooterButtons'

export default {
  name: 'DialogItemAdd',
  data () {
    return {
      form: null,
      error: null,
      loadAddForm: false,
      loadBtn: false,
      addForm: {
        type: '20'
      },
      addFormRules: {
        name: [
          { required: true, message: 'Укажите название', trigger: 'blur' }
        ],
        type: [{ required: true, message: 'Выберите роль', trigger: 'blur' }]
      }
    }
  },
  mounted () {
  },
  props: {
    visible: {
      required: true
    }
  },
  components: {
    FooterButtons
  },
  methods: {
    onOpen () {
      this.autoFocus()
    },
    close () {
      this.$emit('close')
    },
    autoFocus () {
      this.$refs.autoFocus.focus()
    },
    saveForm (close) {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.loadAddForm = !!1

          const er = this.$notify.error({
            title: 'Ошибка',
            message: 'Метод API отсутствует'
          })
          if (er) return

          const payLoad = {
            type: this.addForm.type,
            schema: {
              text: this.addForm.name,
              compendium: this.addForm.compendium
            }
          }
          this.$api.device
            .create(payLoad)
            .then(() => {
              this.$notify.success({
                title: 'Успешно',
                message: 'Данные сохранены'
              })
              if (close) {
                this.$emit('update')
                this.$emit('close')
              } else {
                this.$emit('update')
                this.addForm = {
                  type: '20'
                }
                this.autoFocus()
              }
            })
            .catch((response) => {
              this.$notify.error({
                title: 'Ошибка',
                message: response.response.data.message
              })
            })
            .finally(() => {
              this.loadAddForm = !!0
            })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">

.dialog {
  &__description {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #aaaeba;
    margin: 25px 0 40px 0;

    &_mini {
      font-size: 14px;
    }
  }

  &__select {
    margin: 10px 0;
    width: 100%;
  }
  &__btns {
    float: right;
  }
}
.dialog-form {
  &__title {
    margin: 6px 0 24px 0;
    font-size: 15px;

    color: #909399;
  }
}
.el-button {
  margin-top: 5px;
}
</style>
